import { __decorate, __metadata } from "tslib";
import { Expose, Type } from 'class-transformer-global-storage';
import { EditorDefinition, CrudEndpoints, IdItemModel, ItemModelProp, ModelId } from '@core/shared/model';
import { NotificationItem } from '.';
import { NotificationRecipientRestraints } from './notification-recipient.restraints';
import { UseRestraints } from '@core/shared/restraints';
let NotificationRecipientItem = /*#__PURE__*/(() => {
  let NotificationRecipientItem = class NotificationRecipientItem extends IdItemModel {
    toString() {
      return "NotificationRecipient " + this.name;
    }
  };
  __decorate([Expose(), __metadata("design:type", Object)], NotificationRecipientItem.prototype, "creationDate", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", Number)], NotificationRecipientItem.prototype, "ownerId", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], NotificationRecipientItem.prototype, "updateDate", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValue: false
  }), __metadata("design:type", Boolean)], NotificationRecipientItem.prototype, "read", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValue: false
  }), __metadata("design:type", Boolean)], NotificationRecipientItem.prototype, "disposed", void 0);
  __decorate([Expose(), Type(() => NotificationItem), __metadata("design:type", NotificationItem)], NotificationRecipientItem.prototype, "notification", void 0);
  NotificationRecipientItem = __decorate([EditorDefinition([], {
    allowAllExposed: true,
    useCrudEndpoint: 'public'
  }), CrudEndpoints({
    public: '/notifications'
  }), UseRestraints(NotificationRecipientRestraints), ModelId("NotificationRecipientItem") // auto-generated by generate-model-ids
  ], NotificationRecipientItem);
  return NotificationRecipientItem;
})();
export { NotificationRecipientItem };